export default "__VITE_ASSET__BV84WjGM__"